import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../GlobalContext';

const SetJasaPinjaman = () => {
  const navigate = useNavigate();
    const { api } = useGlobalContext();

  const [formData, setFormData] = useState({
    jasaD: 1.2,
    jasaC: 2,
    jasaA: 2,
    sifatD: 1,
    sifatC: 2,
    sifatA: 2,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

const getSetupData = async () => {
  try {
      const response = await api.get('/api/setup/jasapinjaman');
    const data = response.data;
    setFormData({
      jasaD: data.jasapinj_a || 1.2,
      jasaC: data.jasapinj_b || 2,
      jasaA: data.jasapinj_c || 2,
      sifatD: data.metode_a || 1,
      sifatC: data.metode_b || 2,
      sifatA: data.metode_c || 2,
    });
    setLoading(false);
  } catch (err) {
    console.error(err);
    setError('Failed to fetch data from the server.');
    setLoading(false);
  }
};

const saveSetupData = async () => {
  try {
    await axios.patch('http://localhost:5000/setup/jasa', {
      jasapinj_a: parseFloat(formData.jasaD),
      jasapinj_b: parseFloat(formData.jasaC),
      jasapinj_c: parseFloat(formData.jasaA),
      metode_a: parseInt(formData.sifatD),
      metode_b: parseInt(formData.sifatC),
      metode_c: parseInt(formData.sifatA),
    });
    alert('Data updated successfully!');
  } catch (err) {
    console.error(err);
    setError('Failed to update data.');
  }
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const numericValue = name.startsWith('jasa') ? value.replace(/[^\d.]/g, '') : value;

    setFormData({
      ...formData,
      [name]: numericValue,
    });
  };

  useEffect(() => {
    getSetupData();
  }, []);

  if (loading) {
    return <div>Loading data...</div>;
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div className="row">
        <div className="col-16">
          <div className="card card-info">
            <div className="card-header">
              <h3 className="card-title">Setup Jasa Pinjaman</h3>
            </div>
            <div className="card-body">
              {error && <div className="alert alert-danger">{error}</div>}
              <ul className="nav nav-tabs" id="custom-content-above-tab" role="tablist">
                <li className="nav-item">
                  <a className="nav-link active" id="Unit_D-tab" data-toggle="pill" href="#Unit_D" role="tab">Unit D</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" id="Unit_C-tab" data-toggle="pill" href="#Unit_C" role="tab">Unit C</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" id="Unit_A-tab" data-toggle="pill" href="#Unit_A" role="tab">Unit A</a>
                </li>
              </ul>

              <div className="tab-content" id="custom-content-above-tabContent">
                {/* Unit D */}
                <div className="tab-pane fade show active" id="Unit_D" role="tabpanel">
                  <div className="form-group row mt-3 ml-3">
                    <label htmlFor="jasaD" className="col-sm-4 col-form-label">Jasa D %</label>
                    <div className="col-sm-5">
                      <input
                        type="text"
                        className="form-control"
                        id="jasaD"
                        name="jasaD"
                        value={formData.jasaD}
                        style={{ textAlign: 'right' }}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row mt-2 ml-3">
                    <label htmlFor="sifatD" className="col-sm-4 col-form-label">Sifat</label>
                    <div className="col-sm-7">
                      <select
                        className="form-control"
                        id="sifatD"
                        name="sifatD"
                        value={formData.sifatD}
                        onChange={handleInputChange}
                      >
                        <option value="1">Menurun</option>
                        <option value="2">Flat</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Unit C */}
                <div className="tab-pane fade" id="Unit_C" role="tabpanel">
                  <div className="form-group row mt-3 ml-3">
                    <label htmlFor="jasaC" className="col-sm-4 col-form-label">Jasa C %</label>
                    <div className="col-sm-5">
                      <input
                        type="text"
                        className="form-control"
                        id="jasaC"
                        name="jasaC"
                        value={formData.jasaC}
                        style={{ textAlign: 'right' }}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row mt-2 ml-3">
                    <label htmlFor="sifatC" className="col-sm-4 col-form-label">Sifat</label>
                    <div className="col-sm-7">
                      <select
                        className="form-control"
                        id="sifatC"
                        name="sifatC"
                        value={formData.sifatC}
                        onChange={handleInputChange}
                      >
                        <option value="1">Menurun</option>
                        <option value="2">Flat</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Unit A */}
                <div className="tab-pane fade" id="Unit_A" role="tabpanel">
                  <div className="form-group row mt-3 ml-3">
                    <label htmlFor="jasaA" className="col-sm-4 col-form-label">Jasa A %</label>
                    <div className="col-sm-5">
                      <input
                        type="text"
                        className="form-control"
                        id="jasaA"
                        name="jasaA"
                        value={formData.jasaA}
                        style={{ textAlign: 'right' }}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row mt-2 ml-3">
                    <label htmlFor="sifatA" className="col-sm-4 col-form-label">Sifat</label>
                    <div className="col-sm-7">
                      <select
                        className="form-control"
                        id="sifatA"
                        name="sifatA"
                        value={formData.sifatA}
                        onChange={handleInputChange}
                      >
                        <option value="1">Menurun</option>
                        <option value="2">Flat</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => navigate('/')}>
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={() => saveSetupData()}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetJasaPinjaman;
